<template>
	<div id="main-header" class="ud-header bg-transparent absolute top-0 left-0 z-40 w-full flex items-center">
      <div class="container flex relative">
        <div class="background-white">
          <div class="px-4 w-60 max-w-full">
            <a href="https://gbprestigepaysagement.com" class="navbar-logo w-full block py-5">
              <img
                src="@/assets/images/logo.png"
                alt="logo"
                class="w-full header-logo"
              />
            </a>
          </div>
        </div>
        <div class="flex -mx-4 items-center justify-between">
          <div class="flex px-4 justify-between items-center w-full">
            <button id="navbarToggler"
              class="block absolute right-4 top-1/2 -translate-y-1/2 lg:hidden focus:ring-2 ring-primary px-3 py-[6px] rounded-lg">
              <span class="relative w-[30px] h-[2px] my-[6px] block bg-white"></span>
              <span class="relative w-[30px] h-[2px] my-[6px] block bg-white"></span>
              <span class="relative w-[30px] h-[2px] my-[6px] block bg-white"></span>
            </button>

            <nav id="navbarCollapse"
              class="absolute py-5 lg:py-0 lg:px-4 xl:px-6 bg-white lg:bg-transparent shadow-lg rounded-lg lg:max-w-[250px] md:w-full
                lg:max-w-full lg:w-full right-4 top-full hidden lg:block lg:static lg:shadow-none">
              <ul class="lg:flex">
                <li v-for="menuItem in menuElements" :key="menuItem.hash" class="relative group ud-menu-scroll">
                  <a
                    :href="menuItem.hash"
                    v-html="menuItem.label"
                    class="text-base text-dark lg:text-white lg:group-hover:opacity-70
                      lg:group-hover:text-white group-hover:text-primary py-2 lg:py-6 lg:inline-flex lg:px-0
                      flex lg:mr-0">
                  </a>
                </li>
              </ul>
            </nav>
            <!-- <div
              class="submission-btn text-base font-medium text-white bg-white
              bg-opacity-50 rounded-lg py-3 px-2 hover:bg-opacity-100
              hover:text-dark signUpBtn duration-300 ease-in-out 
              lg:flex items-center justify-end hidden pr-16 lg:pr-1
              cursor-pointer"
            >
                <img width="80px" :src="submissionSvg"/>
                
            </div> -->
            <a href="https://contact.gbprestigepaysagement.com">
              <div class="wrapper bg-white
                bg-opacity-50 rounded-lg py-3 px-2 hover:bg-opacity-100
                hover:text-dark signUpBtn duration-300 ease-in-out 
                lg:flex items-center justify-end hidden pr-16 lg:pr-1
                cursor-pointer">
                <span class="label"><img width="140px" :src="submissionSvg" alt="tirelire"/></span>
                <div class="contents ">
                    <div class="inner">
                        <span style="text-align: center;">Soumission Gratuite</span>
                    </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
	name: "Header",
  data() {
    return {
      menuElements: [
        {
          label: "Accueil",
          hash: "#accueil",
        },
        {
          label: "À propos",
          hash: "#apropos",
        },
        {
          label: "Services",
          hash: "#services",
        },
        {
          label: "Faq",
          hash: "#faq",
        },
        // {
        //   label: "Témoignages",
        //   hash: "#temoignages",
        // }
      ],
      submissionSvg: require('@/assets/images/illustrations/piggybank.svg')
    }
  },
  mounted: () => {
    const pageLink = document.querySelectorAll(".ud-menu-scroll a");
    pageLink.forEach((elem) => {
      elem.addEventListener("click", (e) => {
        e.preventDefault();
        const section = document.querySelector(elem.getAttribute("href"));
        if (!!section) {
          section.scrollIntoView({
            behavior: "smooth",
            offsetTop: 1 - 60,
          });
        }
      });
    });
  }
};
</script>

<style lang="scss">
#main-header {
  transition: max-height .7s ease-in-out;
  max-height: 6rem;

  &.sticky {
    max-height: 5rem;
  }
}

.wrapper {
    width:auto;
}

.contents {
    white-space: nowrap;
}

.contents .inner {
    -webkit-transition: width 0.5s ease-in-out;
    -moz-transition: width 0.5s ease-in-out;
    -o-transition: width 0.5s ease-in-out;
    transition: width 0.5s ease-in-out;
}

.wrapper:hover .contents .inner {
    width: 100%;
}

.submission-btn {
  border-radius: 4px;
}

.header-seperator {
  border-left-color: #152107;
  border-left-width: 2px;
}

</style>
